import rest from '@modules/rest'
import upload from '@modules/upload'
import { getFileUrl, getUploadEndpoint } from '@modules/fileHelpers'
import { DEPENDENTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import { mapSystemFields, mapCustomFields } from '@convenia/employee-organisms/SystemFields/Dependents/content/mappers'
import { mapDependent, mapDependentInput } from '@convenia/employee-organisms/SystemFields/Dependents/content/mappers/dependents'

export const getDependents = async (params) => {
  try {
    const { employeeId, companyId } = params
    const { data = [] } = await rest.get(`/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/admission`)
    const dependents = data.map(({ customFieldValues, ...dependent }) => ({
      ...mapDependent(dependent, { getFileUrl, employeeId }),
      customFieldValues,
    }))

    return [ null, dependents ]
  } catch (err) {
    return [ err, null ]
  }
}

export const createDependent = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const body = mapDependentInput({ data, schema })

    const response = await rest.post(
      `/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/admission`,
      { body, headers: { bcv: true } }
    )

    const dependent = mapDependent(response?.data, { getFileUrl, employeeId })

    return [ null, dependent ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateDependent = async (data, params) => {
  try {
    const dependentId = data?.id
    const { employeeId, companyId, schema } = params
    const body = mapDependentInput({ data, schema, entityId: dependentId })

    await rest.put(
      `/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/${dependentId}/admission`,
      { body, headers: { bcv: true } }
    )

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteDependent = async (data, params) => {
  try {
    const dependentId = data?.id
    const isCreating = typeof dependentId !== 'string'

    if (isCreating)
      return [ null, null ]

    const { employeeId, companyId } = params

    await rest.delete(`/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/${dependentId}/admission`)

    return [ null, null ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadDependentFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'dependent')

    const data = await upload({ files, endpoint })

    return [ null, data || [] ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getSystemFields = async ({ employeeId, companyId }) => {
  try {
    const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/admission`

    const { data } = await rest.get(url, { params: { area: DEPENDENTS_AREA.LABEL } })

    const systemFields = mapSystemFields(data.sections || [])
    const customFields = mapCustomFields(data.sections || [])

    return [ null, { systemFields, customFields } ]
  } catch (err) {
    return [ err, null ]
  }
}
